import script from "./OperatorApplicationConfigDownload.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationConfigDownload.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationConfigDownload.vue?vue&type=style&index=0&id=a28a889e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a28a889e"]])

export default __exports__